(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 59186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var components_lobbypage_components_PageBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57640);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75741);
/* harmony import */ var theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14808);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var StyledDescriptionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Description__StyledDescriptionWrapper",
  componentId: "sc-wg9h44-0"
})(["", "{}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "h1",
  variant: "h2"
}).withConfig({
  displayName: "Description__StyledTitle",
  componentId: "sc-wg9h44-1"
})(["font-size:44px;font-weight:normal;margin-top:10px;margin-bottom:20px;line-height:1;", " color:", ";", "{font-size:70px;}"], theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontCondensed */ .gH, theme_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].blackDark */ .Z.blackDark, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "p",
  variant: "h2"
}).withConfig({
  displayName: "Description__StyledSubtitle",
  componentId: "sc-wg9h44-2"
})(["margin-top:0;margin-bottom:10px;font-size:18px;font-weight:normal;"]);
var StyledDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "div",
  variant: "body1"
}).withConfig({
  displayName: "Description__StyledDescription",
  componentId: "sc-wg9h44-3"
})(["margin-bottom:10px;margin-top:0;font-size:14px;font-weight:400;color:", ";white-space:break-spaces;line-height:1.57;", "{margin-bottom:20px;}p{margin:0;}a{text-decoration:underline;}ul{margin:0.5em 0;padding-inline-start:1.3em;li::marker{color:", ";}}"], theme_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, function (p) {
  return p.theme.breakpoints.up("md");
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.red;
}); //to remove

var Description = function Description(_ref2) {
  var data = _ref2.data,
      parentPageType = _ref2.parentPageType;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledDescriptionWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_lobbypage_components_PageBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      thisPageName: data.title,
      parentPageType: parentPageType
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledTitle, {
      children: data.title
    }), data.subtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSubtitle, {
      children: data.subtitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDescription, {
      dangerouslySetInnerHTML: {
        __html: data === null || data === void 0 ? void 0 : data.description
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Description);

/***/ }),

/***/ 43277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// https://usehooks.com/useDebounce/
 // T is a generic type for value parameter, our case this will be string

function useDebounce(value, delay) {
  // State and setters for debounced value
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Update debounced value after delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.

    return function () {
      clearTimeout(handler);
    };
  }, [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}

/***/ }),

/***/ 56949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _imageMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15283);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CdnImage = function CdnImage(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), _objectSpread({
    loader: _imageMap__WEBPACK_IMPORTED_MODULE_2__/* .cloudflareLoader */ .O
  }, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (CdnImage);

/***/ }),

/***/ 51484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MV": function() { return /* binding */ LOCALE; },
/* harmony export */   "Wj": function() { return /* binding */ CONSTRUCTION; },
/* harmony export */   "k6": function() { return /* binding */ mapsApiKey; }
/* harmony export */ });
var mapsApiKey = "AIzaSyCj0ryj5kLFxMmeAGUP3X4lftkoVfmcCuU";
var LOCALE = {
  EN: "en",
  HE: "he"
};
var CONSTRUCTION = "construction";

/***/ }),

/***/ 70166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ unSlugify; },
/* harmony export */   "ZP": function() { return /* binding */ slugify; }
/* harmony export */ });
/* unused harmony export getSlugLastPart */
// function encodeURISlug(name: string) {
//   return process.env.NODE_ENV !== "development"
//     ? name
//     : encodeURIComponent(name)
// }
function slugify(name) {
  return name.toLowerCase().trim().replace(/\s+/g, "-"); // return forceEncode ? encodeURISlug(slug) : slug
}
function unSlugify(name) {
  return name.toLowerCase().trim().replace("-", "  "); // return forceEncode ? encodeURISlug(slug) : slug
} // function that extract only the last part of a slug

function getSlugLastPart(slug) {
  return (slug === null || slug === void 0 ? void 0 : slug.split("/").pop()) || "";
}

/***/ }),

/***/ 57640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7885);
/* harmony import */ var common_utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51484);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32125);
/* harmony import */ var _common_NextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44074);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








 //Styles




var StyledBreadcrumbs = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "PageBreadcrumbs__StyledBreadcrumbs",
  componentId: "sc-t3c85e-0"
})(["", "{padding-top:20px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledActiveLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
  displayName: "PageBreadcrumbs__StyledActiveLink",
  componentId: "sc-t3c85e-1"
})(["font-weight:bold;color:", ";"], function (p) {
  return p.theme.colors.black;
});

var PageBreadcrumbs = function PageBreadcrumbs(_ref) {
  var thisPageName = _ref.thisPageName,
      parentPageType = _ref.parentPageType,
      assetType = _ref.assetType;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__.useTranslations)("breadcrumbs");

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      asPath = _useRouter.asPath;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (window !== undefined) {
      setTimeout(function () {
        var lastLi = document.querySelector("#breadcrumbs li:last-child"); // add aria-current="page" to the last li

        lastLi === null || lastLi === void 0 ? void 0 : lastLi.setAttribute("aria-current", "page");
      });
    }
  }, []);

  var getParentPageUrl = function getParentPageUrl(parentPageType) {
    return parentPageType === "all-assets" ? "/assets-list/all-assets" : parentPageType === "assets-list" ? "/assets-list/offices" : parentPageType === "about" ? "/about/about-us" : parentPageType === "investments" ? "/about/about-us" : "/investor-relations";
  };

  var breadcrumbArray = [{
    position: 1,
    name: t("main"),
    item: "/"
  }, {
    position: 2,
    name: t(parentPageType),
    item: getParentPageUrl(parentPageType)
  }, {
    position: 3,
    name: thisPageName,
    item: asPath
  }];

  if (assetType) {
    var assetItem = {
      position: 3,
      name: t(assetType),
      item: "/assets-list/".concat(assetType)
    };
    breadcrumbArray.splice(2, 0, assetItem);
    breadcrumbArray[3].position = 4;
  }

  if (assetType === common_utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONSTRUCTION */ .Wj) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBreadcrumbs, {
        id: "breadcrumbs",
        separator: "//",
        "aria-label": t("navAria"),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "body2",
            children: t("main")
          })
        }), thisPageName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          href: "/construction",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "body2",
            children: t("construction")
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledActiveLink, {
          variant: "body2",
          children: thisPageName || t("construction")
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
        itemListElements: breadcrumbArray
      })]
    });
  } //Render


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBreadcrumbs, {
      id: "breadcrumbs",
      separator: "//",
      "aria-label": t("navAria"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t("main")
        })
      }), parentPageType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: getParentPageUrl(parentPageType),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t(parentPageType)
        })
      }), assetType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: "/assets-list/".concat(assetType),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t(assetType)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledActiveLink, {
        variant: "body2",
        children: thisPageName
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
      itemListElements: breadcrumbArray
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageBreadcrumbs);

/***/ }),

/***/ 22490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports StyledNoResultsTitle, StyledNoResultsSubTitle */
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22318);
/* harmony import */ var common_NextLink__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44074);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







var StyledNoResultsDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "NoResultsWrap__StyledNoResultsDiv",
  componentId: "sc-133fl8h-0"
})(["width:100%;margin-top:37px;margin-bottom:37px;display:flex;flex-direction:column;align-items:center;", "{margin-top:80px;margin-bottom:80px;padding:0 15px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledNoResultsTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "NoResultsWrap__StyledNoResultsTitle",
  componentId: "sc-133fl8h-1"
})(["color:", ";font-size:24px;font-weight:500;"], function (p) {
  return p.theme.colors.black;
});
var StyledNoResultsSubTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "NoResultsWrap__StyledNoResultsSubTitle",
  componentId: "sc-133fl8h-2"
})(["color:", ";font-size:16px;margin-top:15px;", "{width:100%;}"], function (p) {
  return p.theme.colors.black;
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "NoResultsWrap__StyledLink",
  componentId: "sc-133fl8h-3"
})(["text-decoration:underline;"]);

var NoResultsWrap = function NoResultsWrap(_ref) {
  var searchValue = _ref.searchValue,
      isChanging = _ref.isChanging;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_4__.useTranslations)("searchWebsite");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNoResultsDiv, {
    children: !isChanging ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledNoResultsTitle, {
        children: [t("noResultsTitle"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_NextLink__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          passHref: true,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
            children: t("goToHomepage")
          })
        })]
      }), searchValue && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledNoResultsSubTitle, {
        children: [t("noResultsDescription"), " ", "\"".concat(searchValue, "\"")]
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNoResultsTitle, {
      children: t("searching")
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (NoResultsWrap);

/***/ }),

/***/ 39894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ StyledFlexBoxRow; },
/* harmony export */   "N6": function() { return /* binding */ StyledFlexBoxCol; }
/* harmony export */ });
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19393);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43832);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83023);
/* harmony import */ var api_SiteId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8163);
/* harmony import */ var common_utils_slugify__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70166);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32125);
/* harmony import */ var _common_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43277);
/* harmony import */ var _NoResultsWrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22490);
/* harmony import */ var _SearchBar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46663);
/* harmony import */ var _SearchResultBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64751);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













 //Styles




var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
  displayName: "SearchAmotPage__StyledContainer",
  componentId: "sc-5romwg-0"
})(["position:relative;z-index:21;display:flex;width:100%;padding:16px;box-sizing:border-box;margin-bottom:50px;"]);
var StyledStretch = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SearchAmotPage__StyledStretch",
  componentId: "sc-5romwg-1"
})(["width:100%;box-sizing:border-box;"]);
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).attrs({
  variant: "h2",
  component: "h1"
}).withConfig({
  displayName: "SearchAmotPage__StyledTitle",
  componentId: "sc-5romwg-2"
})(["font-size:20px;line-height:2;letter-spacing:0.4px;padding:10px 0px;height:60px;"]);
var StyledFlexBoxRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z).withConfig({
  displayName: "SearchAmotPage__StyledFlexBoxRow",
  componentId: "sc-5romwg-3"
})(["margin:0px;margin-bottom:", ";margin-top:", ";display:flex;flex-direction:row;gap:", ";box-sizing:border-box;place-items:", ";width:100%;width:", ";height:", ";justify-content:", ";align-items:", ";"], function (p) {
  return p.$mb ? p.$mb : "0";
}, function (p) {
  return p.$mt ? p.$mt : "0";
}, function (p) {
  return p.$gap;
}, function (p) {
  return p.$center ? "center" : "none";
}, function (p) {
  return p.$width;
}, function (p) {
  return p.$height;
}, function (p) {
  return p.$justify ? p.$justify : "initial";
}, function (p) {
  return p.$align ? p.$align : "initial";
});
var StyledFlexBoxCol = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(StyledFlexBoxRow).withConfig({
  displayName: "SearchAmotPage__StyledFlexBoxCol",
  componentId: "sc-5romwg-4"
})(["flex-direction:column;"]);
var StyledNoResultsDiv = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SearchAmotPage__StyledNoResultsDiv",
  componentId: "sc-5romwg-5"
})(["width:100%;margin-top:37px;margin-bottom:37px;display:flex;flex-direction:column;align-items:center;", "{margin-top:80px;margin-bottom:80px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var SearchAmotPage = function SearchAmotPage() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var query = router.query;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_13__.useTranslations)("searchWebsite");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      firstPageRender = _useState[0],
      setFirstPageRender = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      numberOfResults = _useState2[0],
      setNumberOfResults = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""),
      searchValue = _useState3[0],
      setSearchValue = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isSearching = _useState4[0],
      setIsSearching = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      searchResult = _useState5[0],
      setSearchResult = _useState5[1];

  var debouncedSearchTerm = (0,_common_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_4__/* .useDebounce */ .N)(searchValue, 200);
  var siteId = (0,api_SiteId__WEBPACK_IMPORTED_MODULE_1__/* .UseSiteId */ .Xk)(); // Effect for API call

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var timeout = false;
    setIsSearching(true);
    api__WEBPACK_IMPORTED_MODULE_0__.getSitesSearchSearchParam(debouncedSearchTerm, siteId).then(function (result) {
      if (timeout) return;

      if (!result || (result === null || result === void 0 ? void 0 : result.status) !== 200) {
        setNumberOfResults(0);
        setSearchResult([]);
      } else {
        var _result$data;

        setNumberOfResults(result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.length);
        setSearchResult(result === null || result === void 0 ? void 0 : result.data);
      }

      setIsSearching(false);
      router.replace({
        pathname: "/search",
        query: {
          searchText: debouncedSearchTerm
        }
      });
    });
    return function () {
      timeout = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, siteId]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    // on first render check query and set result to be related to
    if (query.searchText && !firstPageRender) {
      setSearchValue((0,common_utils_slugify__WEBPACK_IMPORTED_MODULE_14__/* .unSlugify */ .A$)(query.searchText));
      setFirstPageRender(true);
    }
  }, [query, firstPageRender]); //Render

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(StyledContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(StyledFlexBoxCol, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_SearchBar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          withShadow: true,
          setSearchValue: setSearchValue,
          searchValue: searchValue
        }), (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) !== 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(StyledTitle, {
          children: "".concat(numberOfResults, " ").concat(t("searchResultNumber"), " \"").concat(debouncedSearchTerm, "\"")
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
          children: !isSearching && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(StyledNoResultsDiv, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_NoResultsWrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
              searchValue: searchValue
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(StyledStretch, {
          children: searchResult.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_SearchResultBox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
              data: item
            }, index);
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (SearchAmotPage);

/***/ }),

/***/ 46663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7397);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39803);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);










var StyledShadowWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SearchBar__StyledShadowWrap",
  componentId: "sc-4teml5-0"
})(["", ""], function (p) {
  return p.$withShadow ? "border-radius: 8px; box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.16); background-color: #fff;" : "";
});
var StyledTextField = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
  displayName: "SearchBar__StyledTextField",
  componentId: "sc-4teml5-1"
})([".MuiOutlinedInput-root{border-radius:8px;background-color:", ";border:none;font-size:16px;}.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline{border-color:", ";}.MuiOutlinedInput-input{padding:20px 0px;}.MuiOutlinedInput-adornedStart{padding-right:0px;}.MuiOutlinedInput-adornedEnd{padding-left:3px;}.MuiInputAdornment-positionStart{padding-right:0px;margin-left:0px;margin:15px;}.MuiInputAdornment-positionEnd{margin:15px;}"], function (p) {
  return p.theme.colors.white;
}, function (p) {
  return p.theme.colors.white;
});

var SearchBar = function SearchBar(_ref) {
  var _ref$withShadow = _ref.withShadow,
      withShadow = _ref$withShadow === void 0 ? false : _ref$withShadow,
      handleKeyDown = _ref.handleKeyDown,
      setSearchValue = _ref.setSearchValue,
      searchValue = _ref.searchValue,
      onSearchIconClick = _ref.onSearchIconClick;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_5__.useTranslations)("searchWebsite");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledShadowWrap, {
    $withShadow: withShadow,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledTextField, {
      autoFocus: true,
      variant: "outlined",
      placeholder: t("searchPlaceholder"),
      value: searchValue,
      role: "search",
      "aria-label": "\u05E1\u05D2\u05D5\u05E8 \u05E8\u05DB\u05D9\u05D1 \u05D7\u05D9\u05E4\u05D5\u05E9 \u05E2\u05DD \u05DE\u05E7\u05E9 ESC",
      inputProps: {
        "aria-label": t("searchField"),
        style: {
          order: 1
        }
      },
      InputProps: {
        onChange: function onChange(e) {
          setSearchValue(e.target.value);
        },
        onKeyDown: handleKeyDown,
        endAdornment: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            style: {
              order: 0
            },
            position: "start",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
              "aria-label": t("searchButton"),
              onClick: onSearchIconClick,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                src: "/searchIconGrey.svg",
                alt: "search-icon",
                width: "16px",
                height: "16px"
              })
            })
          }), searchValue !== "" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_material_ui_core_InputAdornment__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            style: {
              order: 1
            },
            position: "end",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
              onClick: function onClick() {
                return setSearchValue("");
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                src: "/xIconGreyCircle.svg",
                alt: "x-icon",
                width: "16px",
                height: "16px"
              })
            })
          })]
        })
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SearchBar);

/***/ }),

/***/ 64751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28696);
/* harmony import */ var common_NextLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44074);
/* harmony import */ var common_utils_CdnImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56949);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32125);
/* harmony import */ var theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14808);
/* harmony import */ var _SearchAmotPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39894);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);













var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SearchResultBox__StyledWrapper",
  componentId: "sc-61pxyq-0"
})(["display:flex;max-width:100%;padding:15px 0px;background-color:", ";box-sizing:border-box;:not(:last-child){border-bottom:1px solid ", ";}", "{display:block;}"], function (p) {
  return p.theme.colors.white;
}, function (p) {
  return p.theme.colors.activitiesBorder;
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).attrs({
  variant: "body1",
  component: "h3"
}).withConfig({
  displayName: "SearchResultBox__StyledTitle",
  componentId: "sc-61pxyq-1"
})(["", ";color:", ";font-size:18px;line-height:1.22;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;box-sizing:border-box;"], theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontCondensed */ .gH, function (p) {
  return p.theme.colors.black;
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).attrs({
  variant: "body1",
  component: "div"
}).withConfig({
  displayName: "SearchResultBox__StyledSubtitle",
  componentId: "sc-61pxyq-2"
})(["color:", ";font-size:14px;line-height:1.22;flex-shrink:0;position:relative;max-height:1.2em;padding:", ";p{padding:0;margin:0;}overflow:hidden;"], function (p) {
  return p.theme.colors.darkGray;
}, function (p) {
  return p.locale === "he" ? "0 0 0 0" : "0 0.5rem 0 0";
});
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SearchResultBox__StyledLink",
  componentId: "sc-61pxyq-3"
})(["", ";color:", ";font-size:14px;line-height:1.57;"], theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_5__/* .fontCondensed */ .gH, function (p) {
  return p.theme.colors.red;
});
var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SearchResultBox__StyledImageContainer",
  componentId: "sc-61pxyq-4"
})(["display:flex;justify-content:center;background-color:", ";border-radius:8px;flex-shrink:0;width:100px;height:75px;", "{width:127px;height:90px;}"], function (p) {
  return p.theme.colors.alabaster;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(common_utils_CdnImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "SearchResultBox__StyledImage",
  componentId: "sc-61pxyq-5"
})(["border-radius:4px;"]);
var StyledTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SearchResultBox__StyledTextWrapper",
  componentId: "sc-61pxyq-6"
})(["max-width:calc(100% - 124px);justify-content:space-between;display:flex;flex-direction:column;", "{max-width:calc(100% - 125px);}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_3___default())).withConfig({
  displayName: "SearchResultBox__StyledArrow",
  componentId: "sc-61pxyq-7"
})(["", ""], function (p) {
  return p.$hebrew ? "" : "-webkit-transform: scaleX(-1); transform: scaleX(-1);";
});

var SearchResultBox = function SearchResultBox(_ref) {
  var _data$description;

  var data = _ref.data;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_10__.useTranslations)("searchWebsite");

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(),
      locale = _useRouter.locale;

  var SUPERMARKET_PAGE = "Shared.Pages.Assets.Supermarkets.SupermarketPage, Shared, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null";
  var INVESTOR_PAGE = "Shared.Pages.Investors.InvestorsPage, Shared, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null";

  var getHref = function getHref() {
    if (data.type === SUPERMARKET_PAGE) {
      return "/assets-list/supermarkets?slug=".concat(data === null || data === void 0 ? void 0 : data.slug);
    }

    if (data.type === INVESTOR_PAGE) {
      return data !== null && data !== void 0 && data.reportFileLink ? "".concat(data.reportFileLink) : "/".concat(data === null || data === void 0 ? void 0 : data.slug);
    }

    return "/".concat(data === null || data === void 0 ? void 0 : data.slug);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(common_NextLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      href: "".concat(getHref()),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_SearchAmotPage__WEBPACK_IMPORTED_MODULE_6__/* .StyledFlexBoxRow */ .Jv, {
        $gap: "24px",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledImageContainer, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
            children: data.type === INVESTOR_PAGE ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledImage, {
              src: "/documentIcon.svg",
              alt: data === null || data === void 0 ? void 0 : data.title,
              width: "34px",
              height: "44px",
              objectFit: "contain"
            }) : (data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledImage, {
              src: data === null || data === void 0 ? void 0 : data.image,
              alt: data === null || data === void 0 ? void 0 : data.title,
              width: isDesktop ? "127px" : "100px",
              height: isDesktop ? "90px" : "75px",
              objectFit: "cover"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(StyledTextWrapper, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_SearchAmotPage__WEBPACK_IMPORTED_MODULE_6__/* .StyledFlexBoxCol */ .N6, {
            $gap: isDesktop ? "7px" : "5px",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledTitle, {
              children: data === null || data === void 0 ? void 0 : data.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledSubtitle, {
              locale: locale,
              dangerouslySetInnerHTML: {
                __html: data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.slice(0, isDesktop ? 220 : 100)
              }
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_SearchAmotPage__WEBPACK_IMPORTED_MODULE_6__/* .StyledFlexBoxRow */ .Jv, {
            $gap: "8px",
            $align: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledLink, {
              children: t("learnMore")
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledArrow, {
              src: "/arrowIcon.svg",
              alt: "search-icon",
              width: "4.9px",
              height: "9.2px",
              $hebrew: locale === "he"
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SearchResultBox);

/***/ }),

/***/ 86901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(28696);
// EXTERNAL MODULE: ./common/StickyImagePageLayout.tsx + 1 modules
var StickyImagePageLayout = __webpack_require__(19441);
// EXTERNAL MODULE: ./components/searchAmot/SearchAmotPage.tsx
var SearchAmotPage = __webpack_require__(39894);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./common/Description.tsx
var Description = __webpack_require__(59186);
// EXTERNAL MODULE: ./components/contact-us/ContactFormIframe.tsx
var ContactFormIframe = __webpack_require__(73212);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/contact-us/ContactUsPage.tsx








 //Styles




var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__StyledContent",
  componentId: "sc-160ov3p-0"
})(["padding-top:50px;"]);
var StyledFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__StyledFormWrapper",
  componentId: "sc-160ov3p-1"
})(["padding:15px;border:1px solid ", ";border-radius:15px;margin-bottom:60px;", "{padding:19px 30px 0px;}"], function (p) {
  return p.theme.colors.activitiesBorder;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactUsPage__StyledContentWrapper",
  componentId: "sc-160ov3p-2"
})(["padding:0 16px;margin-top:30px;margin-bottom:30px;", "{padding:0;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledDescription = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "p",
  variant: "body1"
}).withConfig({
  displayName: "ContactUsPage__StyledDescription",
  componentId: "sc-160ov3p-3"
})(["margin-bottom:20px;margin-top:0;font-size:14px;color:", ";"], function (p) {
  return p.theme.colors.black;
}); //Types

var ContactUsPage = function ContactUsPage(_ref) {
  var _data$contact, _data$contact2, _data$poster, _data$poster2, _image$media, _image$media2, _image$media3, _poster$media, _data$contact3, _data$contact3$shortD, _data$contact4, _data$contact4$addres, _data$contact5, _data$contact5$parkin, _data$contact6, _data$contact6$email, _data$contact7, _data$contact7$email, _data$contact8, _data$contact8$email, _data$contact9, _data$contact9$phoneN, _data$contact10, _data$contact10$phone, _data$contact11, _data$contact11$phone;

  var data = _ref.data;
  var t = (0,next_intl_cjs_production_min.useTranslations)("contactForm");
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var image = isDesktop ? (_data$contact = data.contact) === null || _data$contact === void 0 ? void 0 : _data$contact.logoDesktop : (_data$contact2 = data.contact) === null || _data$contact2 === void 0 ? void 0 : _data$contact2.logoMobile;
  var poster = isDesktop ? (_data$poster = data.poster) === null || _data$poster === void 0 ? void 0 : _data$poster.posterDesktop : (_data$poster2 = data.poster) === null || _data$poster2 === void 0 ? void 0 : _data$poster2.posterMobile; //Render

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StickyImagePageLayout/* default */.Z, {
      imageUrl: image === null || image === void 0 ? void 0 : (_image$media = image.media) === null || _image$media === void 0 ? void 0 : _image$media.publicUrl,
      altText: image === null || image === void 0 ? void 0 : (_image$media2 = image.media) === null || _image$media2 === void 0 ? void 0 : _image$media2.altText,
      type: image === null || image === void 0 ? void 0 : (_image$media3 = image.media) === null || _image$media3 === void 0 ? void 0 : _image$media3.type,
      poster: poster === null || poster === void 0 ? void 0 : (_poster$media = poster.media) === null || _poster$media === void 0 ? void 0 : _poster$media.publicUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description/* default */.Z, {
          data: {
            title: data === null || data === void 0 ? void 0 : data.navigationTitle,
            // subtitle: data?.metaDescription,
            description: data === null || data === void 0 ? void 0 : (_data$contact3 = data.contact) === null || _data$contact3 === void 0 ? void 0 : (_data$contact3$shortD = _data$contact3.shortDescription) === null || _data$contact3$shortD === void 0 ? void 0 : _data$contact3$shortD.value
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContentWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledDescription, {
            children: [t("address"), " ", data === null || data === void 0 ? void 0 : (_data$contact4 = data.contact) === null || _data$contact4 === void 0 ? void 0 : (_data$contact4$addres = _data$contact4.address) === null || _data$contact4$addres === void 0 ? void 0 : _data$contact4$addres.value]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledDescription, {
            children: [t("parking"), " ", data === null || data === void 0 ? void 0 : (_data$contact5 = data.contact) === null || _data$contact5 === void 0 ? void 0 : (_data$contact5$parkin = _data$contact5.parkingLot) === null || _data$contact5$parkin === void 0 ? void 0 : _data$contact5$parkin.value]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SearchAmotPage/* StyledFlexBoxRow */.Jv, {
            $gap: "12px",
            $align: "self-start",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "mailto:".concat(data === null || data === void 0 ? void 0 : (_data$contact6 = data.contact) === null || _data$contact6 === void 0 ? void 0 : (_data$contact6$email = _data$contact6.email) === null || _data$contact6$email === void 0 ? void 0 : _data$contact6$email.value),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "/emailIcon.svg",
                alt: "emailIcon",
                width: 17,
                height: 17
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "mailto:".concat(data === null || data === void 0 ? void 0 : (_data$contact7 = data.contact) === null || _data$contact7 === void 0 ? void 0 : (_data$contact7$email = _data$contact7.email) === null || _data$contact7$email === void 0 ? void 0 : _data$contact7$email.value),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDescription, {
                children: data === null || data === void 0 ? void 0 : (_data$contact8 = data.contact) === null || _data$contact8 === void 0 ? void 0 : (_data$contact8$email = _data$contact8.email) === null || _data$contact8$email === void 0 ? void 0 : _data$contact8$email.value
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SearchAmotPage/* StyledFlexBoxRow */.Jv, {
            $gap: "12px",
            $align: "self-start",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "tel:".concat(data === null || data === void 0 ? void 0 : (_data$contact9 = data.contact) === null || _data$contact9 === void 0 ? void 0 : (_data$contact9$phoneN = _data$contact9.phoneNumber) === null || _data$contact9$phoneN === void 0 ? void 0 : _data$contact9$phoneN.value),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "/phoneIcon.svg",
                alt: "phoneIcon",
                width: 17,
                height: 17
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "tel:".concat(data === null || data === void 0 ? void 0 : (_data$contact10 = data.contact) === null || _data$contact10 === void 0 ? void 0 : (_data$contact10$phone = _data$contact10.phoneNumber) === null || _data$contact10$phone === void 0 ? void 0 : _data$contact10$phone.value),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDescription, {
                style: {
                  direction: "ltr"
                },
                children: data === null || data === void 0 ? void 0 : (_data$contact11 = data.contact) === null || _data$contact11 === void 0 ? void 0 : (_data$contact11$phone = _data$contact11.phoneNumber) === null || _data$contact11$phone === void 0 ? void 0 : _data$contact11$phone.value
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactFormIframe/* default */.Z, {
            withCompany: true,
            generalMessage: true
          })
        })]
      })
    })
  });
};

/* harmony default export */ var contact_us_ContactUsPage = (ContactUsPage);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./src/pages/contact-us.tsx






var ContactUs = function ContactUs(_ref) {
  var _data$ogImage, _data$ogImage$media;

  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: data === null || data === void 0 ? void 0 : data.metaTitle,
      description: data === null || data === void 0 ? void 0 : data.metaDescription,
      additionalMetaTags: [{
        name: "keywords",
        content: data.metaKeywords
      }],
      openGraph: {
        title: (data === null || data === void 0 ? void 0 : data.ogTitle) || (data === null || data === void 0 ? void 0 : data.metaTitle),
        description: (data === null || data === void 0 ? void 0 : data.ogDescription) || (data === null || data === void 0 ? void 0 : data.metaDescription),
        images: [{
          url: (data === null || data === void 0 ? void 0 : (_data$ogImage = data.ogImage) === null || _data$ogImage === void 0 ? void 0 : (_data$ogImage$media = _data$ogImage.media) === null || _data$ogImage$media === void 0 ? void 0 : _data$ogImage$media.publicUrl) || ""
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact_us_ContactUsPage, {
      data: data
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var contact_us = (ContactUs);

/***/ }),

/***/ 13673:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(86901);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7611,719,5847,3722,3709,9441,9774,2888,179], function() { return __webpack_exec__(13673); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);